//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useEffect, useContext, useState, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
import * as moment from "moment";
import useForm from "helpers/useForm";
// custom pages
import Context from "context/context";

import masterbenefit from "apis/contractCode/contractCode";
import { mpcStyles } from "./styles";
import useDebounce from "helpers/useDebounce";
import Loader from "components/Loader/Loader";
import { exportHeaders } from "./export";
import searchIcon from "assets/img/Search_Icon.png";
import audit from "apis/audit/audit";
import access from "config/access";
import HistoryTable from "components/Table/History/HistoryTable";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Table from "components/Table/Table";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import Grid from "@material-ui/core/Grid";
import FilterListIcon from "@material-ui/icons/FilterList";
import Card from "@material-ui/core/Card";
import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

// material-ui icons
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import MenuIcon from "@material-ui/icons/Menu";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import HistoryIcon from "@material-ui/icons/History";
import { useTranslation } from 'react-i18next';
import { createContractCodeValidate } from "helpers/validateRules/auth";

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      marginTop: 0,
    },
  },
})(TextField);

const GlobalCss = withStyles({
  "@global": {
    ".MuiOutlinedInput-root": {
      borderRadius: 20,
      marginTop: 0,
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 0,
    },
  },
})(() => null);

const initialValues = {
  shipto: '',
  billto: '',
  pmaType: '',
  contractCode: '',
  loyalty: '',
  systemManaged: ''
};

export default function Locations(props) {
  const { state, dispatch } = useContext(Context);
  const { get, search, filter, contractCodeExport, getDropDownList, contractCodeCreate, getDetailpma } =
    masterbenefit();
  const {
    values,
    errors,
    handleSubmit,
    setErrors,
    handleChange,
    setUpdateValue,
  } = useForm(initialValues, handleCreate, createContractCodeValidate);
  const { getAudit } = audit();

  const classes = mpcStyles();

  const [mpcData, setMpcData] = useState([]);
  const [loyselected, setLoySelected] = useState(false);
  const [sysselected, setSysSelected] = useState(false);
  const [datacontract, setDataContract] = useState([]);



  const [mpcDatafilter, setMpcDataFilter] = useState([]);

  const [salesCategory, setSalesCategory] = useState([]);
  const [org, setOrg] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [filterCard, setFilterCard] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState({});
  const [selectedSales, setSelectedSales] = useState({});
  const [exportData, setExportData] = useState([]);
  const [response, setResponse] = useState({
    filter: false,
  });
  const [searchValue, setSearchValue] = useState("");
  const searchBounceValues = useDebounce(searchValue);
  const [isLoading, setIsLoading] = useState(false);
  const [alreadyClicked, setalreadyClicked] = useState(false);

  
  const [newShipto, setNewShipto] = useState({
    isNew: false,
    shipto: '',
    billto: '',
    typeCode: '',
    contractcode:'',
    pmatype:'',
    loyalty:'',
    systemmanaged:''
  });
  const { t, i18n } = useTranslation()
  const [states, setstates] = useState({
    filter: false,
    contractCode: "",
    systemManaged: null,
    loyalty: null,
    pmaType: "",
    historyLoader: false,
    pmaDropdown: [],
    contractCodeDropDown: []
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  const history = useHistory();
  const location = useLocation();

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "CONTRACT CODE"],
    });
  }, []);

  // handling api calls
  useEffect(() => {
    if (state.userInfo && Object.keys(state.userInfo).length > 0) {
      states.filter
        ? handleFilter()
        : searchValue.length > 0
          ? handleSearch()
          : handleGetMpc();
    }
  }, [state.userInfo, offset]);

  //
  useEffect(() => {
    // if ((typeof values.loyalty == 'boolean' && typeof values.systemManaged == 'boolean')||!values) {
      handleGetPmaAndContractCode();
    // }
  }, [values.systemManaged, values.loyalty,values.pmaType,searchBounceValues,newShipto]);

  async function handleGetPmaAndContractCode() {
    let obj = {};
   
    // if (newShipto?.shipto&&((values.loyalty == true && values.systemManaged == true) || (values.loyalty == false && values.systemManaged == false) ||!(values))) {
      obj = { ...obj, system_managed: values?.systemManaged, loyalty: values?.loyalty,id:newShipto?.shipto };

      if (values?.pmaType) {
        obj = { ...obj, pma_type: values.pmaType };
        // handleChange({ name: 'contractCode', value: '' });
      }
      let res = await getDetailpma(obj);
      if (res) {
       
        setStates({
          ...state,
          pmaDropdown: res?.pmaData,
          contractCodeDropDown: res?.contractCode
        });
        setDataContract(res?.contractCode)
       if(res && res?.contractCodesysandloy != null && typeof res?.contractCodesysandloy?.loyalty !='undefined'){
   

        // if(!(sysselected)){
        //   values.loyalty = Boolean(res?.contractCodesysandloy?.loyalty);
        //   handleChange({ name: 'loyalty', value: res?.contractCodesysandloy?.loyalty });
        //   // console.log(values,'1234',typeof res?.contractCodesysandloy?.loyalty)
        // }
        // if(!(sysselected)){
        //   values.systemManaged=Boolean(res?.contractCodesysandloy?.system_managed);
        //   handleChange({ name: 'systemManaged', value: res?.contractCodesysandloy?.system_managed });
        // }
      }

        return;
      }
    // }

    // setStates({
    //   ...state,
    //   pmaDropdown: [],
    //   contractCodeDropDown: []
    // });
    // handleChange({ name: 'pmaType', value: '' });
    // handleChange({ name: 'contractCode', value: '' });
  }

  // mpc api func
  const handleGetMpc = async () => {
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let fillterdata = await getDropDownList(values)
      console.log(fillterdata, "kkk")
      let res = await get(values);
      if (res) {
        setMpcData(res.data);
        setCount(res.count);
        dispatch({ type: "SET_LOADING", payload: false });
      }
      if (fillterdata) {
        // const filteredMap  = new Map(
        //   res.data
        //     .filter((obj) => obj.PMA_TYPE !== null && obj.Thrive_Prefix !== null && obj.Tier !== null&& obj.privilege_code !== null&& obj.privilege_type !== null)
        //     .map((obj) => [{ PMA_TYPE: obj.PMA_TYPE, Thrive_Prefix: obj.Thrive_Prefix, Tier: obj.Tier, privilege_code: obj.privilege_code, privilege_type: obj.privilege_type }])
        // );

        console.log(fillterdata, "response")
        setMpcDataFilter(fillterdata.data)
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // handling search api
  useEffect(() => {
    let offsetValue = location?.state?.offset;
    if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch();
    } else if (offsetValue) {
      setOffset(offsetValue);
      location.state = undefined;
    } else {
      setOffset(1);
    }
  }, [searchBounceValues]);

  // search api func
  const handleSearch = async () => {
    setStates({
      contractCode: "",
      systemManaged: null,
      loyalty: null,
      pmaType: "",
      filter: false
    });
    setResponse({ ...response, filter: false });
    setFilterCard(false);
    setSelectedOrg({});
    setSelectedSales({});
    try {
      let values = {
        searchValue: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await search(values);
      dispatch({ type: "SET_LOADING", payload: false });
      if (res) {
        if (res?.count == 0 && res?.data?.length == 1 && res?.isNew) {
          setNewShipto({
            isNew: true,
            shipto: res.data[0]?.shipto,
            billto: res.data[0]?.billto,
            typeCode: res.data[0]?.customer_account_type_code,
            contractcode:res.data[0]?.contract_code,
             pmatype:res.data[0]?.pma_type,
            loyalty:res.data[0]?.loyalty,
            systemmanaged:res.data[0]?.system_managed
          })
          setCount(res.count);
        } else {
          if(res?.data){
            setMpcData(res?.data);
          }else{
            setMpcData([])
          }
          setCount(res?.count);
          
          setNewShipto({
            isNew: false,
            shipto: '',
            billto: '',
            typeCode: '',
            contractcode:'',
            pmatype:'',
            loyalty:'',
           systemmanaged:''
          })
        }
        return;
      }
      setMpcData([]);
    } catch (e) {
      dispatch({ type: "SET_LOADING", payload: false });
      console.log({ e });
    }
  };

  // filter api func
  const handleFilter = async () => {
    setStates({ filter: true });
    setSearchValue("");
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      if (states.contractCode) {
        values = {
          ...values,
          contractCode: states.contractCode
        };
      }
      if (states.pmaType) {
        values = { ...values, pmaType: states.pmaType };
      }
      if (states.systemManaged != null) {
        values = { ...values, systemManaged: states.systemManaged };
      }
      if (states.loyalty != null) {
        values = { ...values, loyalty: states.loyalty };
      }

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await filter(values);
      if (res) {
        setMpcData(res.data);
        setCount(res.count);
        setFilterCard(false);
        setResponse({ filter: true });
        dispatch({ type: "SET_LOADING", payload: false });
      } else {
        setFilterCard(false);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // export api function
  const handleExport = async () => {
    let values = {};
    if (searchValue) {
      values = { ...values, searchValue };
    }
    if (states.contractCode) {
      values = {
        ...values,
        contractCode: states.contractCode
      };
    }
    if (states.pmaType) {
      values = { ...values, pmaType: states.pmaType };
    }
    if (typeof states.systemManaged === "boolean") {
      values = { ...values, systemManaged: states.systemManaged };
    }
    if (typeof states.loyalty === "boolean") {
      values = { ...values, loyalty: states.loyalty };
    }

    dispatch({ type: "SET_LOADING", payload: true });
    setIsLoading(true);
    let res = await contractCodeExport(values);
    if (res && res.data) {
      setExportData(res.data);
      dispatch({ type: "SET_LOADING", payload: false });
      setIsLoading(false);
      if (res.data.length === 0) {
        toast.success(t("No Data Found"), { toastId: "no-report-date" });
        return false;
      }
      return true;
    }
  };
  const tableHeading = [
    "Loyalty Id",
    "Customer Account Number",
    "Customer Billto Account Number",
    "Privilege Code",
    "PMA Type",
    "Contract Code",
    "Loyalty",
    "System Managed",
    "View Detail",
    state?.userInfo?.auditAccess? "History":"",
  ];

  const handleGetHistoryData = async (id) => {
    try {
      let values;
      values = {
        recordId: id,
        key: "cc",
      };
      let res = await getAudit(values);
      if (res) {
        setStates({ historyData: res?.data, historyLoader: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  async function handleCreate() {
    try {
      if ((values.loyalty == true && values.systemManaged == true) || (values.loyalty== false && values.systemManaged == false)) {

        if(!alreadyClicked){
        let res = await contractCodeCreate(values);
setalreadyClicked(true)
 if (res && res.type == "success") {
        toast.success(res.message);
        setStates({ ...state, createDialog: false })
        handleChange({ name: 'shipto', value: '' });
        handleChange({ name: 'billto', value: '' });
        handleChange({ name: 'pmaType', value: '' });
        handleChange({ name: 'contractCode', value: '' });
        handleChange({ name: 'loyalty', value: '' });
        handleChange({ name: 'systemManaged', value: '' });
        handleSearch();
        setSysSelected(false);
setalreadyClicked(false)

      } else {
        toast.error(res.message);
        setSysSelected(false)
setalreadyClicked(false)

      }



}
     
    } else {
      return toast.error("System Managed and Loyalty should be same");
      setalreadyClicked(false)
    }
    } catch (err) {
      console.log({ err });
      setalreadyClicked(false)
    }
  }

  const invalidChar = ['~', '`', '!', '#', '$', '%', '^', '*', '(', ')', '_', '+', '=', '', ';', ':', '<', '.', '>', '?', '|', '[', ']', '{', '}', '"', "'"]

  const blockInvalidChar = (e) =>{
    invalidChar.includes(e.key) && e.preventDefault();
    if (e.keyCode === 38 || e.keyCode === 40) {
      e.preventDefault();
    }
  }

  return (
    <React.Fragment>
      <GlobalCss />
      <Grid
        container
        spacing={0}
        onClick={() => {
          filterCard == true && setFilterCard(false);
        }}
      >
        {window.innerWidth < 600 && (
          <Grid xs={12}>
            <IconButton
              style={{ position: "absolute" }}
              onClick={() => {
                dispatch({ type: "SET_SIDEBAR", payload: true });
              }}
            >
              <MenuIcon />
            </IconButton>
            <span className={classes.headerText}>{t('MPC')}</span>
          </Grid>
        )}
        <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
          <div style={{ flex: 0.99 }}>
            <CssTextField
              placeholder={t('Search for shipto or billto')}
              type={"number"}
              variant="outlined"
              onKeyDown={blockInvalidChar}
                onWheel={(e) => e.target.blur()}
              className={classes.searchInput}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {searchValue.length > 0 ? (
                      <CloseOutlinedIcon
                        className={classes.searchInputIcon}
                        onClick={() => {
                          setSearchValue("");
                          setOffset(1);
                          handleGetMpc();
                        }}
                      />
                    ) : (
                      <img
                        src={searchIcon}
                        alt=""
                        width="20px"
                        className={classes.searchInputIcon}
                      />
                    )}
                  </InputAdornment>
                ),
              }}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                setOffset(1);
                if (e.target.value.length == 0) {
                  handleGetMpc();
                }
              }}
              onClick={() => {
                setOffset(offset);
              }}
            />
            <Button
              className={`${classes.filterBtn} dash-1-filter-btn`}
              onClick={() => {
                setFilterCard(!filterCard);
                if (!states.filter) {
                  setStates({
                    systemManaged: "",
                    loyalty: "",
                  });
                }
              }}
            >
              {t('Filter')}
              {response["filter"] && (
                <Badge
                  badgeContent={count == 0 ? null : response["filter"] && count}
                  color="error"
                  classes={{ badge: classes.badge }}
                  max={999999}
                  className={classes.badges}
                ></Badge>
              )}
            </Button>
          </div>
          <CSVLink
            id="csv"
            data={exportData}
            headers={exportHeaders.map(head => {
              return { ...head, label: t(head.label) }
            })}
            filename={
              `Contract-Code` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
          <button
            disabled={isLoading}
            className={classes.exportBtn}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {t('Export')}
          </button>
        </Grid>
      </Grid>

      {filterCard && (
        <div className={classes.filterCardDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ float: "right" }}>
              <Card className={classes.filterCard}>
                <Grid
                  container
                  spacing={2}
                  className={classes.filterCardGridContainer}
                >
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("Pma Type")}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.pmaType}
                      onChange={(e) => {
                        setStates({ pmaType: e.target.value });
                      }}
                    >
                      {mpcDatafilter.filter((obj, index, self) => {
                        return index === self.findIndex((o) => o['pma_type'] === obj['pma_type']);
                      }).filter((obj) => obj.pma_type != null).map((obj, i) =>
                        <MenuItem value={obj.pma_type}>{t(obj.pma_type)}</MenuItem>
                      )}
                    </TextField>
                  </Grid>
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("Contract Code")}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.contractCode}
                      onChange={(e) => {
                        setStates({ contractCode: e.target.value });
                      }}
                    >
                      {mpcDatafilter.filter((obj, index, self) => {
                        return index === self.findIndex((o) => o['contract_code'] === obj['contract_code']);
                      }).filter((obj) => obj.contract_code != null).map((obj, i) =>
                        <MenuItem value={obj.contract_code}>{t(obj.contract_code)}</MenuItem>
                      )}
                    </TextField>
                  </Grid>
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("System Managed")}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.systemManaged}
                      onChange={(e) => {
                        setStates({ systemManaged: e.target.value });
                      }}
                    >
                      <MenuItem value={true}>{t("Yes")}</MenuItem>
                      <MenuItem value={false}>{t('No')}</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t('Loyalty')}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.loyalty}
                      onChange={(e) => {
                        setStates({ loyalty: e.target.value });
                      }}
                    >
                      <MenuItem value={true}>{t("Yes")}</MenuItem>
                      <MenuItem value={false}>{t("No")}</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid
                    item
                    sm={2}
                    xs={12}
                    className={classes.filterCardBtnGrid}
                  >
                    <Grid container spacing={0}>
                      <Grid item xs={12}>
                        <Button
                          className={classes.filterCardApplyBtn}
                          onClick={() => {
                            console.log({states});
                            if (
                              states.pmaType == "" &&
                              typeof states.systemManaged != "boolean" &&
                              states.contractCode == "" &&
                              typeof states.loyalty != "boolean"
                            ) {
                              toast.error(t("Please select atleast one field!"), { toastId: "filterValidate" });
                              return;
                            }                            
                            handleFilter();
                            setCount(0);
                            setOffset(1);
                            setResponse({ filter: false });
                          }}
                        >
                          {t('Apply')}
                        </Button>
                      </Grid>
                      {states.filter && (
                        <Grid item xs={12}>
                          <Button
                            className={classes.filterCardResetBtn}
                            onClick={() => {
                              setStates({
                                filter: false,
                                contractCode: "",
                                systemManaged: "",
                                loyalty: "",
                                pmaType: ""
                              });
                              setOffset(1);
                              setFilterCard(false);
                              setSelectedOrg({});
                              setSelectedSales({});
                              handleGetMpc();
                              setCount(0);
                              setResponse({ filter: false });
                            }}
                          >
                            {t('Reset')}
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </div>
      )}
      <Loader Loading={state.loading} top={"15%"}>
        <Grid container style={{ marginTop: 22 }}>
          <Grid item xs={12} sm={12} lg={12}>
            <div className={classes.tableDiv}>
              {count > 0 ? <Table
                headings={tableHeading.map((i) => (
                  <div key={t(i)}
                    className={i === "Org name" ? classes.orgNameColumn : null}
                  >
                    {t(i)}
                  </div>
                ))}
                data={mpcData.map((p, i) => [
                  p?.loyalty_id,
                  p?.shipto,
                  p?.billto,
                  p?.privilege_code ? p?.privilege_code : "-",
                  p?.pma_type ? p?.pma_type : "-",
                  p?.contract_code ? p?.contract_code : "-",
                  [
                    p?.loyalty == true ? (
                      <span style={{ color: "green" }} key={i}>
                        {t('YES')}
                      </span>
                    ) : p.loyalty == false ? (
                      <span style={{ color: "red" }} key={i}>
                        {t('NO')}
                      </span>
                    ) : "-"
                  ],
                  [
                    p?.system_managed == true ? (
                      <span style={{ color: "green" }} key={i}>
                        {t('YES')}
                      </span>
                    ) : p?.system_managed == false ? (
                      <span style={{ color: "red" }} key={i}>
                        {t('NO')}
                      </span>
                    ) : "-"
                  ],
                  [
                    <RemoveRedEyeIcon
                      key={i}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        history.push("/dashboard/contract-code-details", {
                          mpcId: p?.shipto,
                          offset,
                        });
                      }}
                    />,
                  ],
                  state?.userInfo?.auditAccess && (
                    <HistoryIcon
                      key={i}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setStates({
                          historyDialog: true,
                          historyLoader: true,
                        });
                        handleGetHistoryData(p?.shipto);
                      }}
                    />
                  ),
                ])}
                offset={offset}
                count={
                  (count / 10) % 1 == 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              /> :
                <div style={{ textAlign: "center" }}>
                  {!newShipto.isNew && <FolderOpenIcon />}
                  <h2 style={{ textAlign: "center" }}>{!newShipto.isNew && t("No Data Found")}</h2>
                  <div style={{ textAlign: "center", color: "blue", textDecoration: "underline", cursor: 'pointer' }}
                    onClick={() => {
                      if (newShipto?.typeCode == 'B') {
                        return toast.error('System not able to create Contract Code for Billto Id')
                      }
                      handleChange({ name: 'shipto', value: newShipto?.shipto });
                      handleChange({ name: 'billto', value: newShipto?.billto });
                      if(newShipto?.contractcode !=''&& newShipto?.contractcode){
                        handleChange({ name: 'pmaType', value: newShipto?.pmatype  });
                     handleChange({ name: 'contractCode', value:newShipto?.contractcode });
                      handleChange({ name: 'loyalty', value: newShipto?.loyalty  });
                       handleChange({ name: 'systemManaged', value: newShipto?.systemmanaged  });
                     
                      }
                      
                      setStates({
                        createDialog: true,
                      });
                    }}
                  >
                    {newShipto.isNew && t("Create New")}
                  </div>
                </div>}
            </div>
          </Grid>
        </Grid>
      </Loader>

      {/* history */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog ? true : false}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            {t('History')}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
                "Column Name",
                "Description",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at
                    ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}`
                    : "",
                  `${d?.["User.email"]
                    ? d?.["User.email"]
                    : d?.altered_by
                      ? d?.altered_by.charAt(0).toUpperCase() +
                      d?.altered_by.slice(1).toLowerCase()
                      : "-"
                  }`,
                  d?.column_name,
                  `"${d?.old_value}" changed to "${d?.new_value}"`,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog>
      <Dialog
        keepMounted
        open={states?.createDialog}
        aria-describedby='alert-dialog-slide-description'
        fullWidth
        maxWidth='xs'
        disableBackdropClick
      >
        <DialogTitle></DialogTitle>
        <DialogContent>
          <div
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            {t('Create New Contract Code')}
          </div>
          <CloseOutlinedIcon
            className={classes.closeIcon}
            onClick={() => {
              setStates({ ...state, createDialog: false });
              handleChange({ name: 'shipto', value: '' });
              handleChange({ name: 'billto', value: '' });
              handleChange({ name: 'pmaType', value: '' });
              handleChange({ name: 'contractCode', value: '' });
              handleChange({ name: 'loyalty', value: '' });
              handleChange({ name: 'systemManaged', value: '' });
              setSysSelected(false)
            }}
          />
          <DialogContentText id='alert-dialog-slide-description'>
            <Grid
              container
              item
              xs={12}
              spacing={Object.keys(errors).length > 2 ? 0 : 2}
            >
              <Grid item xs={12}>
                <CssTextField
                  id='shipto'
                  label={t('Shipto')}
                  type={'text'}
                  onfocus="this.removeAttribute('readonly')"
                  value={newShipto.shipto}
                  fullWidth
                  disabled
                />
                {errors.shipto && (
                  <span className={classes.errorMsg}>{errors?.shipto}</span>
                )}
              </Grid>
              <Grid item xs={12}>
                <CssTextField
                  id='billto'
                  label={t('Billto')}
                  type={'text'}
                  disabled
                  fullWidth
                  onfocus="this.removeAttribute('readonly')"
                  value={newShipto?.billto}
                />
                {errors.billto && (
                  <span className={classes.errorMsg}>{errors?.billto}</span>
                )}
              </Grid>
              <Grid item xs={12}>
                <CssTextField
                  id='contractCode'
                  label={t('Contract Code')}
                  type={'text'}
                  select
                  fullWidth
                  onfocus="this.removeAttribute('readonly')"
                  value={values.contractCode}
                  onChange={(e) => {
                    let sys=datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed?datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed:e.target.value.toLowerCase().startsWith('t')?true:false
                    if(e.target.value?.toLowerCase()=='p2b' ||  e.target.value?.toLowerCase() =='p1b'){
                      handleChange({ name: 'contractCode', value: e.target.value });
                      handleChange({ name: 'pmaType', value: e.target.value });
                      handleChange({ name: 'loyalty', value:datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty?datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty:e.target.value.toLowerCase().startsWith('t')?true:false });
                      handleChange({ name: 'systemManaged', value: datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed?datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed:e.target.value.toLowerCase().startsWith('t')?true:false });
                      
                    }
                    else{
                      if(values?.pmaType?.toLowerCase()=='p2b' ||  e.target.value?.toLowerCase() =='p1b'){
                        handleChange({ name: 'contractCode', value: e.target.value });
                      handleChange({ name: 'pmaType', value: '' });

                        handleChange({ name: 'loyalty', value:datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty?datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty:e.target.value.toLowerCase().startsWith('t')?true:false });
                        handleChange({ name: 'systemManaged', value: datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed?datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed:e.target.value.toLowerCase().startsWith('t')?true:false });
                        
                      }else{
                        if(values?.pmaType.length>1 && sys){
                          handleChange({ name: 'contractCode', value: e.target.value });
                      handleChange({ name: 'pmaType', value: '' });

                        handleChange({ name: 'loyalty', value:datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty?datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty:e.target.value.toLowerCase().startsWith('t')?true:false });
                        handleChange({ name: 'systemManaged', value: datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed?datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed:e.target.value.toLowerCase().startsWith('t')?true:false });
                        

                        }else{
                          handleChange({ name: 'contractCode', value: e.target.value });
                          handleChange({ name: 'loyalty', value:datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty?datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty:e.target.value.toLowerCase().startsWith('t')?true:false });
                          handleChange({ name: 'systemManaged', value: datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed?datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed:e.target.value.toLowerCase().startsWith('t')?true:false });
                          
                        }
                        
                      }
                     

                    }
                   setLoySelected(true)
                    setSysSelected(true)

                  }}
                >
                  {states?.contractCodeDropDown?.map((i, j) => <MenuItem key={j} value={i.contract_code}>
                    {i.contract_code}
                  </MenuItem>)}
                </CssTextField>
                {errors.contractCode && (
                  <span className={classes.errorMsg}>{errors?.contractCode}</span>
                )}
              </Grid>
              <Grid item xs={12}>
                <CssTextField
                  id='pmaType'
                  label={t('PMA Type')}
                  type={'text'}
                  select
                  fullWidth
                  onfocus="this.removeAttribute('readonly')"
                  value={values.pmaType}
                  onChange={(e) => {
                    if(e.target.value?.toLowerCase()=='p2b' ||  e.target.value?.toLowerCase() =='p1b'){
                      handleChange({ name: 'pmaType', value: e.target.value });
                    handleChange({ name: 'contractCode', value: e.target.value });
                    handleChange({ name: 'loyalty', value:false });
                    handleChange({ name: 'systemManaged', value: false });
                    
                      setSysSelected(false)
                    }else{
                      if(values?.contractCode?.toLowerCase()=='p2b' ||  e.target.value?.toLowerCase() =='p1b'){
                      handleChange({ name: 'pmaType', value: e.target.value });
                    handleChange({ name: 'contractCode', value: '' });

                      }else{
                        if(e.target.value?.length >1 &&values?.contractCode &&values?.loyalty){
                          handleChange({ name: 'pmaType', value: e.target.value });
                    handleChange({ name: 'contractCode', value: '' });



                        }else{
                          handleChange({ name: 'pmaType', value: e.target.value });

                        }

                      }
                      setSysSelected(false)
                    }
                   
                  }}
                >
                  {states?.pmaDropdown?.map((i, j) => <MenuItem key={j} value={i.pma_type}>
                    {i.pma_type}
                  </MenuItem>)}
                </CssTextField>
                {errors.pmaType && (
                  <span className={classes.errorMsg}>{errors?.pmaType}</span>
                )}
              </Grid>
             
              <Grid item xs={12}>
                <CssTextField
                  id='loyalty'
                  label={t('Loyalty')}
                  disabled
                  select
                  fullWidth
                  onfocus="this.removeAttribute('readonly')"
                  value={values?.loyalty}
                  onChange={(e) => {
                    setLoySelected(true)
                    setSysSelected(true)
                    handleChange({ name: 'loyalty', value: e.target.value });
                  }}
                >
                  
                  <MenuItem key={1} value={true}>
                    {t("Yes")}
                  </MenuItem>
                  <MenuItem key={0} value={false}>
                    {t("No")}
                  </MenuItem>
                  
                </CssTextField>
                {errors.loyalty && (
                  <span className={classes.errorMsg}>{errors.loyalty}</span>
                )}
              </Grid>
              <Grid item xs={12}>
                <CssTextField
                  id='systemManaged'
                  label={t('System Managed')}
                  disabled
                  select
                  fullWidth
                  onfocus="this.removeAttribute('readonly')"
                  value={values?.systemManaged}
                  onChange={(e) => {
                    setSysSelected(true)
                    handleChange({ name: 'systemManaged', value: e.target.value });
                  }}
                >
                  <MenuItem key={1} value={true}>
                    {t("Yes")}
                  </MenuItem>
                  <MenuItem key={0} value={false}>
                    {t("No")}
                  </MenuItem>
                </CssTextField>
                {errors.systemManaged && (
                  <span className={classes.errorMsg}>{errors.systemManaged}</span>
                )}
              </Grid>
             
              <Grid item xs={12}></Grid>
            </Grid>
            <div className={classes.popupBtnDiv}>
              <button className={classes.submitBtn} onClick={handleSubmit} disabled={alreadyClicked}  >
                {!state.loading ? t('Create') : `${t('Please wait')}..`}
              </button>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
